import React from "react";
import MerchantMobileBottomNav from "./MerchantMobileBottomNav";
import MerchantMobileDrawer from "./MerchantMobileDrawer";
import MerchantMobileHeader from "./MerchantMobileHeader";

export default function MerchantMobileShell({
  activeBottomNavKey,
  activeDrawerKey,
  apiOverlay,
  avatarText,
  bannerLinkPath,
  bottomNavItems,
  children,
  currentPath,
  isDarkMode,
  merchantAccountId,
  merchantAccountName,
  navItems,
  onLogout,
  onToggleDarkMode,
  pageLabel,
  pageTitle,
}) {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const touchStartXRef = React.useRef(0);
  const drawerRef = React.useRef(null);

  React.useEffect(
    function closeDrawerOnRouteChange() {
      setIsDrawerOpen(false);
    },
    [currentPath],
  );

  function handleTouchStart(event) {
    if (!event.changedTouches || !event.changedTouches.length) {
      return;
    }

    touchStartXRef.current = event.changedTouches[0].clientX;
  }

  function handleTouchEnd(event) {
    if (!event.changedTouches || !event.changedTouches.length) {
      return;
    }

    const deltaX = event.changedTouches[0].clientX - touchStartXRef.current;

    if (deltaX < -60) {
      setIsDrawerOpen(false);
    }
  }

  return (
    <div className={"merchant-shell merchant-portal-shell merchant-mobile-shell" + (isDarkMode ? " merchant-dark" : "")}>
      <MerchantMobileHeader
        avatarText={avatarText}
        pageLabel={pageLabel}
        pageTitle={pageTitle}
        onOpenDrawer={function openDrawer() {
          setIsDrawerOpen(true);
        }}
      />

      <MerchantMobileDrawer
        activeKey={activeDrawerKey}
        bannerLinkPath={bannerLinkPath}
        drawerRef={drawerRef}
        isDarkMode={isDarkMode}
        isOpen={isDrawerOpen}
        merchantAccountId={merchantAccountId}
        merchantAccountName={merchantAccountName}
        navItems={navItems}
        onClose={function closeDrawer() {
          setIsDrawerOpen(false);
        }}
        onLogout={onLogout}
        onToggleDarkMode={onToggleDarkMode}
        onTouchEnd={handleTouchEnd}
        onTouchStart={handleTouchStart}
      />

      <div className="merchant-mobile-page-stack">
        <div className="merchant-mobile-page-scroll">
          {children}
          {apiOverlay}
        </div>
      </div>

      <MerchantMobileBottomNav activeKey={activeBottomNavKey} items={bottomNavItems} />
    </div>
  );
}
